function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2116",
  "data-name": "Group 2116",
  transform: "translate(0 -0.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(0 0.001)",
  fill: "#eeeff3"
})), /*#__PURE__*/React.createElement("g", {
  id: "description_black_24dp",
  transform: "translate(13.47 13.48)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M0,0H23.06V23.06H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  d: "M14.175,2.567A1.928,1.928,0,0,0,12.811,2H5.922A1.927,1.927,0,0,0,4,3.922V19.3a1.919,1.919,0,0,0,1.912,1.922h11.54A1.927,1.927,0,0,0,19.373,19.3V8.563a1.889,1.889,0,0,0-.567-1.355L14.175,2.567Zm.394,14.806H8.8a.961.961,0,1,1,0-1.922h5.765a.961.961,0,1,1,0,1.922Zm0-3.843H8.8a.961.961,0,1,1,0-1.922h5.765a.961.961,0,1,1,0,1.922ZM12.648,7.765V3.441l5.285,5.285H13.608A.964.964,0,0,1,12.648,7.765Z",
  transform: "translate(-0.157 -0.078)",
  fill: "#d55050"
})));

var SvgDocumentInsideCircle = function SvgDocumentInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document-inside-circle.a43aef11.svg";
export { ForwardRef as ReactComponent };